<template>
    <div class="login">
        <div class="login_from">
            <div class="login_title">
                <i class="fas fa-cloud"></i>
                United Quartz 管理系統
            </div>
            <form>
                <div class="input_place input_email">
                    <input class="email" placeholder="email" v-model="email" />
                </div>
                <div class="input_place input_password">
                    <input placeholder="password" type="password" v-model="password" />
                </div>
                <div class="error_message">
                    <span v-if="error">信箱或密碼錯誤，請重新輸入</span>
                </div>
                <el-button :loading="load" @click="handleLogin()" type="primary">登入</el-button>
            </form>
        </div>
    </div>
</template>

<script>
import { postLogin } from '@/api'
export default {
    data() {
        return {
            email: '',
            password: '',
            load: false,
            error: false
        }
    },
    methods: {
        handleLogin() {
            this.load = true
            let params = {
                email: this.email,
                password: this.password
            }
            postLogin(params).then(res => {
                if (res.data.token) {
                    localStorage.setItem('uq_token', res.data.token)
                    this.$store.commit('username', res.data.username)
                    this.$store.commit('userlv', res.data.userlv)
                    this.$router.push({ path: '/' })
                } else {
                    this.error = true
                    this.load = false
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.login {
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: #273342;
    .login_from {
        color: $color-white;
        position: absolute;
        width: 400px;
        height: 215px;
        top: 150px;
        left: 0;
        right: 0;
        margin: auto;
        .login_title {
            font-family: $font-1;
            font-size: $font-size-1;
            font-weight: bold;
            margin-bottom: 40px;
            letter-spacing: 2px;
            height: 40px;
            .select_lang {
                position: absolute;
                right: 0;
                top: 40px;
            }
        }
    }
}
.el-input {
    margin-bottom: 20px;
}
.el-button--primary {
    font-family: $font-1;
    background: $color-blue;
    font-weight: bold;
    width: 100%;
}
.input_place {
    position: relative;
}
.input_email::before {
    font-family: 'Font Awesome 5 Free';
    content: '\f0e0';
    font-weight: 900;
    position: absolute;
    top: 13px;
    left: 10px;
    color: $color-black-4;
    vertical-align: middle;
}
.input_password::before {
    font-family: 'Font Awesome 5 Free';
    content: '\f084';
    font-weight: 900;
    position: absolute;
    top: 13px;
    left: 10px;
    color: $color-black-4;
    vertical-align: middle;
}
.input_email {
    margin-bottom: 20px;
}
.error_message {
    height: 40px;
    line-height: 40px;
    font-size: $font-size-5;
    color: $color-red;
    text-align: right;
}
</style>
